<template>
    <div>
        <BaseModal 
            v-if="visible"
            ModalId="modalId"
            :HideModalFun="onHidden"
            :TitleWindow="$t('DrugOrderItemsRemoval.Title')"
            :width="'50%'"
            :height="'auto'"
            @ShownModal="ShownModal"
            :buttons="[
                { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
                { text: $t('Shared.Save'), variant: 'primary', action: emitEventOK },                   
            ]"              
            @Close="close"
        >
        <!--
            <b-row>
                <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="this.$tc('DrugOrderItemsRemoval.DrugName',1)"
                        v-bind:TypeProp="'text'" 
                        v-bind:Name="'drugName'"
                        v-model="value.drugName"
                        v-bind:isReadOnly="true"
                        v-bind:Id="'input_drugName'">                                     
                    </MdEdit>
                </b-col>
                <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="this.$t('DrugOrderItemsRemoval.Ingredient')"
                        v-bind:TypeProp="'text'" 
                        v-bind:Name="'activeIngred'"
                        v-model="value.activeIngred"
                        v-bind:isReadOnly="true"
                        v-bind:Id="'input_activeIngred'">                                     
                    </MdEdit>
                </b-col>
                <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="this.$t('DrugOrderItemsRemoval.ExpirationDate')"
                        v-bind:TypeProp="'date'" 
                        v-bind:Name="'expirationDate'"
                        v-model="value.expirationDate"
                        v-bind:isReadOnly="true"
                        v-bind:Id="'input_expirationDate'">                                     
                    </MdEdit>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="this.$t('DrugOrderItemsRemoval.LotNo')"
                        v-bind:TypeProp="'text'" 
                        v-bind:Name="'lotNo'"
                        v-model="value.lotNo"
                        v-bind:isReadOnly="true"
                        v-bind:Id="'input_lotNo'">                                     
                    </MdEdit>
                </b-col>
                <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="this.$t('DrugOrderItemsRemoval.Location')"
                        v-bind:TypeProp="'text'" 
                        v-bind:Name="'location'"
                        v-model="value.location"
                        v-bind:isReadOnly="true"
                        v-bind:Id="'input_location'">                                     
                    </MdEdit>
                </b-col>
                <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="this.$t('DrugOrderItemsRemoval.Filled')"
                        v-bind:TypeProp="'text'" 
                        v-bind:Name="'qtyFilled'"
                        v-model="value.qtyFilled"
                        v-bind:isReadOnly="true"
                        v-bind:Id="'input_qtyFilled'">                                     
                    </MdEdit>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="this.$t('DrugOrderItemsRemoval.Received')"
                        v-bind:TypeProp="'text'" 
                        v-bind:Name="'qtyReceived'"
                        v-model="value.qtyReceived"
                        v-bind:isReadOnly="true"
                        v-bind:Id="'input_qtyReceived'">                                     
                    </MdEdit>
                </b-col>
                <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="this.$t('DrugOrderItemsRemoval.Available')"
                        v-bind:TypeProp="'text'" 
                        v-bind:Name="'qtyAvailable'"
                        v-model="value.qtyAvailable"
                        v-bind:isReadOnly="true"
                        v-bind:Id="'input_qtyAvailable'">                                     
                    </MdEdit>
                </b-col>
            </b-row>
-->

            <b-row>
                <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="$t('DrugOrderItemsRemoval.QuantityToRemove')"
                        v-bind:TypeProp="'number'" 
                        v-bind:Name="'qtyToMove'"
                        v-bind:Min="'0'"
                        v-bind:StepProp="'1'"
                        v-bind:isAutoFocus="true"
                        v-model="value.qtyToMove"
                        v-bind:isRequired="true"
                        :isValid="isValid('qtyToMove')"
                        v-bind:Id="'input_qtyToMove'">                                     
                    </MdEdit>
                </b-col>
                <b-col lg="4" md="4" sm="12">
                    <MdSelect
                        v-bind:Label="$t('DrugOrderItemsRemoval.Reason')"
                        v-bind:Options="reasonList"
                        v-bind:ModelArray="reasonVModel"
                        v-bind:FieldDescription="'value'"
                        v-bind:FieldCode="'key'"
                        :Input="changeDropDownReason"/>
                </b-col>
                <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="$t('DrugOrderItemsRemoval.Remarks')"
                        v-bind:TypeProp="'text'" 
                        v-bind:Name="'notes'"
                        v-model="value.notes"
                        v-bind:Id="'input_notes'">                                     
                    </MdEdit>
                </b-col>
            </b-row>
           <div class="grid-margin stretch-card mt-3">
			<div class="card activeCard">
			<div class="card-body">	     
			<div class="d-flex align-items-start justify-content-between">
				<h6 v-b-toggle="'ItemRelocationInfo'" class="card-title flex-grow lower-line text-truncate"> {{this.$t('DrugOrderItemsRemoval.ItemsRemovalInfo')}}</h6>      
			</div>

			<div class="float-left col-md-4 text-muted p-item">
				<small>{{this.$tc('DrugOrderItemsRemoval.DrugName',1)}}</small><br>
				<b>{{value.drugName}}</b>        
			</div>

			<div class="float-left col-md-4 text-muted p-item">
				<small>{{this.$t('DrugOrderItemsRemoval.Ingredient')}}</small><br>
				<b>{{value.activeIngred}}</b>
			</div>


             <div class="float-left col-md-2 text-muted p-item">
				<small>{{ this.$t('DrugOrderItemsRemoval.Location') }}</small><br>
				<b>{{value.locationDescription}}</b>
			</div>

			<div class="float-left col-md-2 text-muted p-item">
				<small>{{ this.$t('DrugOrderItemsRemoval.ExpirationDate') }}</small><br>
				<b>{{value.expirationDate}}</b>
			</div>

            <div class="float-left col-md-4 text-muted p-item">
				<small>{{ this.$t('DrugOrderItemsRemoval.LotNo') }}</small><br>
				<b>{{value.lotNo}}</b>
			</div>
            
            <div class="float-left col-md-4 text-muted p-item">
				<small>{{ this.$t('DrugOrderItemsRemoval.Filled') }}</small><br>
				<b>{{value.qtyFilled}}</b>
			</div>
            <div class="float-left col-md-2 text-muted p-item">
				<small>{{ this.$t('DrugOrderItemsRemoval.Received') }}</small><br>
				<b>{{value.qtyReceived}}</b>
			</div>
            <div class="float-left col-md-2 text-muted p-item">
				<small>{{ this.$t('DrugOrderItemsRemoval.Available') }}</small><br>
				<b>{{value.qtyAvailable}}</b>
			</div>
			</div>
		</div>		
            </div>

        </BaseModal>
    </div>
</template>

<script>
import validationMixin from '@/common/validationMixin';
import validationRules from '@/common/validationRules';
import ShowMessage from '@/components/messages/ShowMessage.js';

export default {
    name: 'DrugOrderItemsRemovalEditDlg',
    mixins: [validationMixin, ShowMessage],

    props: {
        value: Object,
        visible: {
            type: Boolean,
            default: false
        },
        reasonList: Array
    },

    data() {
        return {
            modalId: 'ItemsRemovalEditDlgId',
            reasonVModel: null
        }
    },

    watch: {
        visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent= true;
            }
        },
    },

    methods: {
        emitEventCancel() {
            this.emitCloseEvent= false;
            this.$emit('close');
        },

        emitEventOK() {
            if (this.validate()) {
                this.$emit('ok');
            } else {
                if (!this.isValid('reasonCode')) {
                    this.showMessage(this.$tc('Msg.Error'),this.invalidMessage('reasonCode'),"errorAutoHide"); 
                }
                if (!this.isValid('qtyToMove')) {
                    this.showMessage(this.$tc('Msg.Error'),this.invalidMessage('qtyToMove'),"errorAutoHide"); 
                }
            }
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('close');
                this.emitCloseEvent= false;
            }
        },

        ShownModal(){
            this.$nextTick(()=>{
                const el = document.getElementById("input_qtyToMove");
                if(el) el.focus();
            })
        },

        validate() {
            const rules = {
                reasonCode: [
                    validationRules.required(
                        this.$t("DrugOrderItemsRemoval.ReasonCodeRequired")
                    ),
                ],
                qtyToMove: [
                    validationRules.required(
                        this.$t("DrugOrderItemsRemoval.QuantityToMoveRequired")
                    ),
                    validationRules.greaterThan(0,
                        this.$t("DrugOrderItemsRemoval.QuantityToMoveZero")
                    ),
                    validationRules.max(+this.value.qtyAvailable,
                        this.$t("DrugOrderItemsRemoval.QuantityToMoveAvailable")
                    ),
                ],
            }

            return this.validateFields(rules, this.value);
        },

        changeDropDownReason(value) {
            this.value.reasonCode = value ? value.key : null;
        },

        close() {
            this.emitEventCancel();
        }
    }
}
</script>
